/* Arjit4Amply: exit-intent lead-capture popup, trigger/frequency-cap/
   suppression logic ported from the live reference's own real
   sleep-reset.js (fetched directly, not guessed) - the reference ships a
   working implementation of this exact feature, not just a static mockup.

   Device branch uses matchMedia('(hover: hover) and (pointer: fine)')
   rather than a viewport-width check, matching the reference exactly -
   this is a real mouse/trackpad test, so a touch laptop with a mouse
   attached still gets the desktop (exit-intent) behavior it actually has,
   and a desktop-width touch device gets the mobile (scroll/timer)
   behavior it actually needs. */
(function () {
  var dialog = document.getElementById('matre-exit-popup');
  if (!dialog) return;

  var LAST_SHOWN_KEY = 'matre-exit-popup-last-shown';
  var SUBSCRIBED_KEY = 'matre-exit-popup-subscribed';
  var THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

  function getStorage(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function setStorage(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {}
  }

  function isBlocked() {
    var active = document.activeElement;
    if (active && active !== document.body && active.matches('input, textarea, select, [contenteditable="true"]')) return true;
    if (document.querySelector('dialog[open]')) return true;
    if (getStorage(SUBSCRIBED_KEY) === 'true') return true;
    return false;
  }

  function open() {
    if (isBlocked()) return;
    var lastShown = Number(getStorage(LAST_SHOWN_KEY) || 0);
    if (Date.now() - lastShown < THIRTY_DAYS_MS) return;
    dialog.showModal();
    document.body.classList.add('matre-exit-popup-open');
    setStorage(LAST_SHOWN_KEY, String(Date.now()));
  }

  dialog.querySelectorAll('[data-exit-popup-close]').forEach(function (button) {
    button.addEventListener('click', function () {
      dialog.close();
    });
  });

  dialog.addEventListener('close', function () {
    document.body.classList.remove('matre-exit-popup-open');
  });

  /* Arjit4Amply: click-outside-to-close on the native <dialog> - a click
     on the dialog element itself (not a descendant) only happens when the
     click actually lands on the ::backdrop or the dialog's own padding
     box outside its content, so the bounding-rect check distinguishes a
     genuine backdrop click from a click that merely bubbled up to the
     dialog from something inside it. */
  dialog.addEventListener('click', function (event) {
    if (event.target !== dialog) return;
    var rect = dialog.getBoundingClientRect();
    var inside =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;
    if (!inside) dialog.close();
  });

  /* Arjit4Amply: sign-up, same approach as the homepage Sleep Reset form
     (see matre-home-sleep-reset.js for the full reasoning): the phone goes
     to Omnisend via omnisend.identifyContact, then the Shopify newsletter
     form is submitted for real (requestSubmit) so Shopify's hCaptcha can
     add its token. Shopify redirects back to the same page with
     ?customer_posted=true#ExitPopupForm - the anchor tells this form's
     sign-up apart from the homepage form's, and the popup is reopened in
     its "Check your inbox" state. */
  var form = dialog.querySelector('#ExitPopupForm');
  if (form) {
    var success = form.querySelector('.matre-exit-popup__success');
    var again = form.querySelector('[data-exit-popup-again]');
    var submit = form.querySelector('.matre-exit-popup__submit');
    var formParts = '.matre-exit-popup__fields, .matre-exit-popup__submit, .matre-exit-popup__consent';
    var decline = dialog.querySelector('.matre-exit-popup__decline');
    var handedToShopify = false;

    /* "No, thank you" is hidden once signed up - the close button stays. */
    function showSuccess() {
      form.querySelectorAll(formParts).forEach(function (el) {
        el.hidden = true;
      });
      if (decline) decline.hidden = true;
      success.hidden = false;
      success.focus();
    }

    /* Omnisend only accepts international format; an 8-digit number is
       treated as Singapore (+65). Same rule as the homepage form. */
    function normalisePhone(raw) {
      var hasPlus = raw.trim().charAt(0) === '+';
      var digits = raw.replace(/\D/g, '');
      if (!digits) return '';
      if (hasPlus) return '+' + digits;
      if (digits.length === 8) return '+65' + digits;
      return '+' + digits;
    }

    function sendToOmnisend() {
      if (!window.omnisend || typeof window.omnisend.identifyContact !== 'function') return false;
      var contact = { email: form.querySelector('[name="contact[email]"]').value.trim() };
      var firstName = form.querySelector('[name="contact[first_name]"]').value.trim();
      var phone = normalisePhone(form.querySelector('[name="phone"]').value);
      if (firstName) contact.firstName = firstName;
      if (phone) contact.phone = phone;
      try {
        window.omnisend.identifyContact(contact);
        return true;
      } catch (error) {
        return false;
      }
    }

    form.addEventListener('submit', function (event) {
      if (handedToShopify) return;
      event.preventDefault();
      if (submit) submit.disabled = true;
      setStorage(SUBSCRIBED_KEY, 'true');

      /* Give Omnisend's request a moment to leave before the page navigates. */
      var wait = sendToOmnisend() ? 1200 : 0;
      setTimeout(function () {
        handedToShopify = true;
        if (submit) submit.disabled = false;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(submit || undefined);
        } else if (submit) {
          submit.click();
        }
      }, wait);
    });

    if (/[?&]customer_posted=true/.test(window.location.search) && window.location.hash === '#ExitPopupForm') {
      showSuccess();
      dialog.showModal();
      document.body.classList.add('matre-exit-popup-open');
    }

    if (again) {
      again.addEventListener('click', function () {
        success.hidden = true;
        form.querySelectorAll('.matre-exit-popup__fields, .matre-exit-popup__submit, .matre-exit-popup__consent').forEach(function (el) {
          el.hidden = false;
        });
        if (decline) decline.hidden = false;
        form.reset();
      });
    }
  }

  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseout', function (event) {
      if (!event.relatedTarget && event.clientY <= 0) open();
    });
  } else {
    setTimeout(open, 30000);
    window.addEventListener(
      'scroll',
      function () {
        var range = document.documentElement.scrollHeight - window.innerHeight;
        if (range > 0 && window.scrollY / range >= 0.5) open();
      },
      { passive: true }
    );
  }
})();
